import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import IPageList from 'src/dataModel/IPageList';
import IPagenation from 'src/dataModel/IPagenation';
import ICompanyInfo from './ICompanyInfo';
/** 模块状态 */
export default class ModulesState extends ModulesStateBasic { 
    /** 数组 */
    public list: any = []; // 数据列表，被筛选的数据
    public listAll: any = []; // 数据列表，全部（初始化数据）
    /** 排序分组的list */
    public sortList: any = [];
    public pagination: IPagenation = {
         total: 0,
         current: 1,
         defaultCurrent: 1,
         pageSize: 1000,
         onChange: () => { console.log(''); }
    };
 
    public paramCondition: IParamCondition = {};
    /** 被选择的数据 */
    public selectRows: ICompanyInfo[] = []; 
    public indeterminate: boolean = false;
    public checkAll: boolean = false; 
    public submit: boolean = false;
    /** 关键字 */
    public keywords: string = null;
 }
 interface IParamCondition { 
     city?: string;
     connectionTaxId?: string;
     contractUser?: string; 
     country?: string;
     fuzzyConnectionName?: string; 
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/CompanySelection/Modules.State.ts